import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ViewEncapsulation, ChangeDetectionStrategy, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
const _c0 = ["*"];
const _c1 = (a0, a1, a2) => ({
  color: a0,
  opacity: a1,
  fontWeight: a2
});
function TabsComponent_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("background-color", ctx_r2.color);
  }
}
function TabsComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function TabsComponent_div_1_Template_div_click_0_listener() {
      const index_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onActivateTab(index_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TabsComponent_div_1_div_2_Template, 1, 2, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tab_r4 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(3, _c1, tab_r4.active ? ctx_r2.color : "inherit", tab_r4.active ? 1 : 0.7, tab_r4.active ? 500 : "inherit"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tab_r4.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", tab_r4.active);
  }
}
const _c2 = a0 => ({
  maxWidth: "100%",
  width: "100%",
  color: a0
});
const _c3 = () => [1, 2, 3, 4, 5, 6, 7, 8, 9];
const _c4 = () => ["Basic", "Filters"];
const _c5 = (a0, a1) => ({
  color: a0,
  fontWeight: a1
});
function EditImageComponent_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 19);
  }
}
function EditImageComponent_ng_container_16_option_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 37);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formatItem_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", formatItem_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(formatItem_r3);
  }
}
function EditImageComponent_ng_container_16_ng_container_34_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28)(2, "div", 38)(3, "label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 39);
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_ng_container_34_Template_input_change_5_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onChangeCrop());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_ng_container_34_Template_input_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.cropWidth, $event) || (ctx_r1.state.cropWidth = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 38)(7, "label");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 39);
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_ng_container_34_Template_input_change_9_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onChangeCrop());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_ng_container_34_Template_input_ngModelChange_9_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.cropHeight, $event) || (ctx_r1.state.cropHeight = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "p", 40)(11, "button", 41);
    i0.ɵɵlistener("click", function EditImageComponent_ng_container_16_ng_container_34_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCrop());
    });
    i0.ɵɵelementStart(12, "span", 3);
    i0.ɵɵtext(13, " crop ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.labels["width(px)"]);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.labels["width(px)"]);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.cropWidth);
    i0.ɵɵproperty("min", 0)("max", 2000);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.labels["height(px)"]);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.labels["height(px)"]);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.cropHeight);
    i0.ɵɵproperty("min", 0)("max", 2000);
  }
}
function EditImageComponent_ng_container_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20)(2, "p", 21);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 22)(7, "input", 23);
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_Template_input_change_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeQuality());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_Template_input_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.quality, $event) || (ctx_r1.state.quality = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 24);
    i0.ɵɵtext(9);
    i0.ɵɵelementStart(10, "div", 25)(11, "input", 26);
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_Template_input_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.maintainAspectRatio, $event) || (ctx_r1.state.maintainAspectRatio = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 27);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 28)(15, "div", 29)(16, "label");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "input", 30);
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_Template_input_change_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeSize(false));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_Template_input_ngModelChange_18_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.maxWidth, $event) || (ctx_r1.state.maxWidth = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 29)(20, "label");
    i0.ɵɵtext(21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "input", 30);
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_Template_input_change_22_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeSize(true));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_Template_input_ngModelChange_22_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.maxHeight, $event) || (ctx_r1.state.maxHeight = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(23, "p", 21);
    i0.ɵɵtext(24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 31)(26, "div", 32)(27, "select", 33);
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_Template_select_ngModelChange_27_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.state.format, $event) || (ctx_r1.state.format = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_Template_select_change_27_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeFormat());
    });
    i0.ɵɵtemplate(28, EditImageComponent_ng_container_16_option_28_Template, 2, 2, "option", 34);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(29, "div", 35)(30, "span", 25)(31, "input", 36);
    i0.ɵɵlistener("change", function EditImageComponent_ng_container_16_Template_input_change_31_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCropStateChange());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function EditImageComponent_ng_container_16_Template_input_ngModelChange_31_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.showCrop, $event) || (ctx_r1.showCrop = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "span", 21);
    i0.ɵɵtext(33);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(34, EditImageComponent_ng_container_16_ng_container_34_Template, 14, 10, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.labels["Quality"]);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.state.quality + "%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("readonly", ctx_r1.showCrop)("disabled", ctx_r1.showCrop)("ngStyle", i0.ɵɵpureFunction1(34, _c2, ctx_r1.color));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.quality);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.labels["Max dimensions"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("color", ctx_r1.color);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.maintainAspectRatio);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.labels["aspect-ratio"]);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.labels["max-width(px)"]);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.labels["max-width(px)"]);
    i0.ɵɵproperty("readonly", ctx_r1.showCrop)("disabled", ctx_r1.showCrop);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.maxWidth);
    i0.ɵɵproperty("min", 0)("max", 2000);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.labels["max-height(px)"]);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", ctx_r1.labels["max-height(px)"]);
    i0.ɵɵproperty("readonly", ctx_r1.showCrop)("disabled", ctx_r1.showCrop);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.maxHeight);
    i0.ɵɵproperty("min", 0)("max", 2000);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.labels["Format"]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r1.showCrop);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.state.format);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.allFormats);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleProp("color", ctx_r1.color);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.showCrop);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.labels["Crop"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCrop);
  }
}
function EditImageComponent_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "lib-basic-filters", 42);
    i0.ɵɵlistener("changeFilter", function EditImageComponent_ng_container_17_Template_lib_basic_filters_changeFilter_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChangeFilters($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("filterState", ctx_r1.state.basicFilters)("labels", ctx_r1.labels)("color", ctx_r1.color);
  }
}
function EditImageComponent_p_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 43);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(3, _c5, ctx_r1.calculateSize() > 120 ? "#f44336" : "unset", ctx_r1.calculateSize() > 120 ? "500" : "unset"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" size: ", ctx_r1.calculateSize(), "Kb \xA0 ", ctx_r1.format, " ");
  }
}
const _c6 = ["imagePicker"];
const _c7 = (a0, a1, a2) => ({
  width: a0,
  height: a1,
  borderRadius: a2
});
const _c8 = a0 => ({
  borderRadius: a0
});
function NgpImagePickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "button", 5);
    i0.ɵɵlistener("click", function NgpImagePickerComponent_div_0_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onUpload($event));
    });
    i0.ɵɵelementStart(3, "span", 6);
    i0.ɵɵtext(4, "add_a_photo");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "input", 7, 0);
    i0.ɵɵlistener("change", function NgpImagePickerComponent_div_0_Template_input_change_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleFileSelect($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(3, _c7, ctx_r1.config.width, ctx_r1.config.height, ctx_r1.config.borderRadius));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.labels["Upload a image"]);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", "filePicker-" + ctx_r1.uuidFilePicker);
  }
}
function NgpImagePickerComponent_div_1_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(3, _c5, ctx_r1.calculateSize() > 120 ? "#f44336" : "unset", ctx_r1.calculateSize() > 120 ? "500" : "unset"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" size: ", ctx_r1.calculateSize(), "Kb \xA0 ", ctx_r1.state.format, " ");
  }
}
function NgpImagePickerComponent_div_1_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function NgpImagePickerComponent_div_1_button_7_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onUpload($event));
    });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2, "add_a_photo");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.labels["Upload a image"]);
  }
}
function NgpImagePickerComponent_div_1_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function NgpImagePickerComponent_div_1_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onOpenEditPanel());
    });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.labels["Open the editor panel"]);
  }
}
function NgpImagePickerComponent_div_1_a_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19)(1, "span", 6);
    i0.ɵɵtext(2, "cloud_download");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.labels["Download the image"]);
    i0.ɵɵpropertyInterpolate("download", ctx_r1.imageName);
    i0.ɵɵproperty("href", ctx_r1.imageSrc, i0.ɵɵsanitizeUrl);
  }
}
function NgpImagePickerComponent_div_1_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function NgpImagePickerComponent_div_1_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onRemove());
    });
    i0.ɵɵelementStart(1, "span", 6);
    i0.ɵɵtext(2, "delete");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.labels["Remove"]);
  }
}
function NgpImagePickerComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 8);
    i0.ɵɵelement(2, "img", 9);
    i0.ɵɵelementStart(3, "input", 7, 0);
    i0.ɵɵlistener("change", function NgpImagePickerComponent_div_1_Template_input_change_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleFileSelect($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, NgpImagePickerComponent_div_1_p_5_Template, 2, 6, "p", 10);
    i0.ɵɵelementStart(6, "div", 11);
    i0.ɵɵtemplate(7, NgpImagePickerComponent_div_1_button_7_Template, 3, 1, "button", 12)(8, NgpImagePickerComponent_div_1_button_8_Template, 3, 1, "button", 13)(9, NgpImagePickerComponent_div_1_a_9_Template, 3, 3, "a", 14)(10, NgpImagePickerComponent_div_1_button_10_Template, 3, 1, "button", 15);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction3(9, _c7, ctx_r1.config.width, ctx_r1.config.height, ctx_r1.config.borderRadius));
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.imageSrc, i0.ɵɵsanitizeUrl)("ngStyle", i0.ɵɵpureFunction1(13, _c8, ctx_r1.config.borderRadius));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "filePicker-" + ctx_r1.uuidFilePicker);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.calculateSize());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideAddBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideEditBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideDownloadBtn);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.config.hideDeleteBtn);
  }
}
function NgpImagePickerComponent_lib_edit_image_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-edit-image", 21);
    i0.ɵɵlistener("closeModal", function NgpImagePickerComponent_lib_edit_image_2_Template_lib_edit_image_closeModal_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCloseEditPanel($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("imageSrc", ctx_r1.imageSrc)("originImageSrc", ctx_r1.originImageSrc)("initialState", ctx_r1.state)("labels", ctx_r1.labels)("color", ctx_r1.color);
  }
}
const MAX_BUFFER_UNDO_MEMORY = 50;
const convertImageUsingCanvas = (datas, changeHeight = false, state, options) => {
  return new Promise(async (resolve, _) => {
    let img = document.createElement('img');
    img.src = datas + '';
    img.crossOrigin = 'Anonymous';
    let quality = state.quality / 100;
    let maintainRatio = state.maintainAspectRatio;
    img.onload = () => {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      let ratio = img.width / img.height;
      let width = state.maxWidth;
      let height = state.maxHeight;
      if (options?.getDimFromImage) {
        width = img.width;
        height = img.height;
      }
      if (maintainRatio) {
        canvas.width = width;
        canvas.height = width / ratio;
        if (changeHeight) {
          canvas.width = height * ratio;
          canvas.height = height;
        }
      } else {
        canvas.width = width;
        canvas.height = height;
      }
      if (state.basicFilters) {
        ctx.filter = processFilter(state.basicFilters);
      }
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      let type = state.format;
      var dataURI = canvas.toDataURL(`image/${type}`, quality);
      resolve({
        dataUri: dataURI,
        width: canvas.width,
        height: canvas.height
      });
    };
  }).then(data => {
    state.maxHeight = data.height;
    state.maxWidth = data.width;
    if (state.arrayCopiedImages.length <= MAX_BUFFER_UNDO_MEMORY) {
      state.arrayCopiedImages.push({
        lastImage: data.dataUri,
        width: state.maxWidth,
        height: state.maxHeight,
        quality: state.quality,
        format: state.format,
        originImageSrc: state.originImageSrc,
        basicFilters: state.basicFilters
      });
    } else {
      state.arrayCopiedImages[state.arrayCopiedImages.length - 1] = {
        lastImage: data.dataUri,
        width: state.maxWidth,
        height: state.maxHeight,
        quality: state.quality,
        format: state.format,
        originImageSrc: state.originImageSrc,
        basicFilters: state.basicFilters
      };
    }
    return data.dataUri;
  });
  function processFilter(data) {
    return Object.keys(data).map(key => {
      if (['blur'].includes(key)) {
        return `${key}(${data[key]}px)`;
      } else {
        return `${key}(${data[key]})`;
      }
    }).join('');
  }
};
const dragElement = elemnt => {
  var pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;
  if (document.getElementById(elemnt.id + '-header')) {
    /* if present, the header is where you move the DIV from:*/
    document.getElementById(elemnt.id + '-header').onmousedown = dragPressOn;
    document.getElementById(elemnt.id + '-header').ontouchstart = dragPressOn;
  } else {
    /* otherwise, move the DIV from anywhere inside the DIV:*/
    elemnt.ontouchstart = dragPressOn;
    elemnt.onmousedown = dragPressOn;
  }
  function dragPressOn(e) {
    let popup = document.querySelector('#popup');
    popup.style.overflowY = 'hidden';
    e = e || window.event;
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.ontouchend = closeDragElement;
    document.onmouseup = closeDragElement;
    document.ontouchmove = elementDragTouch;
    document.onmousemove = elementDragMouse;
  }
  function elementDragMouse(e) {
    let holderImage = document.getElementById('image-full');
    e = e || window.event;
    pos1 = pos3 - e.clientX;
    pos3 = e.clientX;
    pos2 = pos4 - e.clientY;
    pos4 = e.clientY;
    let newTop = elemnt.offsetTop - pos2;
    let newLeft = elemnt.offsetLeft - pos1;
    let rectHolder = holderImage.getBoundingClientRect();
    let rectElemnt = elemnt.getBoundingClientRect();
    // console.log('====================================');
    // console.log(rectElemnt,rectHolder);
    // console.log('====================================');
    newTop = Math.max(newTop, rectHolder.top);
    newTop = Math.min(newTop, rectHolder.bottom - rectElemnt.height);
    newLeft = Math.max(newLeft, rectHolder.left);
    newLeft = Math.min(newLeft, rectHolder.right - rectElemnt.width);
    elemnt.style.top = newTop + 'px';
    elemnt.style.left = newLeft + 'px';
  }
  function elementDragTouch(e) {
    let holderImage = document.getElementById('image-full');
    e = e || window.event;
    if (e?.changedTouches?.length) {
      pos1 = pos3 - e.changedTouches[0]?.clientX;
      pos3 = e.changedTouches[0]?.clientX;
    }
    if (e?.changedTouches?.length) {
      pos2 = pos4 - e.changedTouches[0]?.clientY;
      pos4 = e.changedTouches[0]?.clientY;
    }
    let newTop = elemnt.offsetTop - pos2;
    let newLeft = elemnt.offsetLeft - pos1;
    let rectHolder = holderImage.getBoundingClientRect();
    let rectElemnt = elemnt.getBoundingClientRect();
    // console.log('====================================');
    // console.log(rectElemnt,rectHolder);
    // console.log('====================================');
    newTop = Math.max(newTop, rectHolder.top);
    newTop = Math.min(newTop, rectHolder.bottom - rectElemnt.height);
    newLeft = Math.max(newLeft, rectHolder.left);
    newLeft = Math.min(newLeft, rectHolder.right - rectElemnt.width);
    elemnt.style.top = newTop + 'px';
    elemnt.style.left = newLeft + 'px';
  }
  function closeDragElement() {
    /* stop moving when mouse button is released:*/
    let popup = document.querySelector('#popup');
    popup.style.overflowY = 'auto';
    document.onmouseup = null;
    document.onmousemove = null;
    document.ontouchend = null;
    document.ontouchmove = null;
  }
};
class TabsComponent {
  constructor() {
    this.labels = [];
    this.indexActivated = 0;
    this.color = '';
    this.indexActivatedChange = new EventEmitter();
  }
  set _labels(value) {
    if (value?.length) {
      this.labels = value.map(el => ({
        active: false,
        label: el
      }));
      this.labels[this.indexActivated].active = true;
    }
  }
  set _indexActivated(index) {
    this.indexActivated = index || 0;
  }
  onActivateTab(itemIndex) {
    this.labels = this.labels.map((el, index) => {
      el.active = itemIndex === index ? true : false;
      return el;
    });
    this.indexActivated = itemIndex;
    this.indexActivatedChange.next(itemIndex);
  }
  ngOnInit() {}
}
TabsComponent.ɵfac = function TabsComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || TabsComponent)();
};
TabsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TabsComponent,
  selectors: [["lib-tabs"]],
  inputs: {
    color: "color",
    _labels: "_labels",
    _indexActivated: "_indexActivated"
  },
  outputs: {
    indexActivatedChange: "indexActivatedChange"
  },
  ngContentSelectors: _c0,
  decls: 4,
  vars: 1,
  consts: [[1, "header"], ["class", "itemlabel bottomLine", 3, "ngStyle", "click", 4, "ngFor", "ngForOf"], [1, "body"], [1, "itemlabel", "bottomLine", 3, "click", "ngStyle"], [3, "backgroundColor", 4, "ngIf"]],
  template: function TabsComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵelementStart(0, "div", 0);
      i0.ɵɵtemplate(1, TabsComponent_div_1_Template, 3, 7, "div", 1);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(2, "div", 2);
      i0.ɵɵprojection(3);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngForOf", ctx.labels);
    }
  },
  dependencies: [i1.NgForOf, i1.NgStyle, i1.NgIf],
  styles: [".header[_ngcontent-%COMP%]{display:flex;padding:0 8px;box-sizing:border-box;justify-content:flex-start;align-items:center;overflow-x:auto;font-size:16px;border-bottom:1px solid #323232}.header[_ngcontent-%COMP%]   .itemlabel[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;padding:.5rem .65rem;min-height:48px;box-sizing:border-box;white-space:nowrap;text-transform:capitalize;cursor:pointer;opacity:.7}.header[_ngcontent-%COMP%]   .itemlabel.bottomLine[_ngcontent-%COMP%]{position:relative;opacity:1}.header[_ngcontent-%COMP%]   .itemlabel.bottomLine[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{position:absolute;width:100%;bottom:0;height:3px}.body[_ngcontent-%COMP%]{padding:16px 8px;min-height:200px}"]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabsComponent, [{
    type: Component,
    args: [{
      selector: 'lib-tabs',
      template: "<div class=\"header\">\n  <div\n    (click)=\"onActivateTab(index)\"\n    *ngFor=\"let tab of this.labels; let index = index\"\n    class=\"itemlabel bottomLine\"\n    [ngStyle]=\"{ color: tab.active ? color : 'inherit', opacity: tab.active ? 1 : 0.7, fontWeight: tab.active ? 500 : 'inherit' }\"\n  >\n    {{ tab.label }}\n    <div *ngIf=\"tab.active\" [style.backgroundColor]=\"this.color\"></div>\n  </div>\n</div>\n\n<div class=\"body\">\n  <ng-content></ng-content>\n</div>\n",
      styles: [".header{display:flex;padding:0 8px;box-sizing:border-box;justify-content:flex-start;align-items:center;overflow-x:auto;font-size:16px;border-bottom:1px solid #323232}.header .itemlabel{display:flex;justify-content:center;align-items:center;padding:.5rem .65rem;min-height:48px;box-sizing:border-box;white-space:nowrap;text-transform:capitalize;cursor:pointer;opacity:.7}.header .itemlabel.bottomLine{position:relative;opacity:1}.header .itemlabel.bottomLine div{position:absolute;width:100%;bottom:0;height:3px}.body{padding:16px 8px;min-height:200px}\n"]
    }]
  }], function () {
    return [];
  }, {
    color: [{
      type: Input
    }],
    _labels: [{
      type: Input
    }],
    _indexActivated: [{
      type: Input
    }],
    indexActivatedChange: [{
      type: Output
    }]
  });
})();
class BasicFiltersComponent {
  constructor() {
    this.changeFilter = new EventEmitter();
    this.state = {
      contrast: 1,
      blur: 0,
      brightness: 1,
      grayscale: 0,
      invert: 0,
      saturate: 1,
      sepia: 0
    };
  }
  set filterState(value) {
    if (value) {
      this.state = JSON.parse(JSON.stringify({
        ...this.state,
        ...value
      }));
    }
  }
  ngOnInit() {
    // this.state = JSON.parse(JSON.stringify({ ...this.state, ...this.filterState }));
    // // console.log('🚀 ~ file: basic-filters.component.ts ~ line 25 ~ BasicFiltersComponent ~ ngOnInit ~ this.state', this.state);
  }
  onChange() {
    this.changeFilter.next(this.state);
  }
}
BasicFiltersComponent.ɵfac = function BasicFiltersComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || BasicFiltersComponent)();
};
BasicFiltersComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: BasicFiltersComponent,
  selectors: [["lib-basic-filters"]],
  inputs: {
    color: "color",
    labels: "labels",
    filterState: "filterState"
  },
  outputs: {
    changeFilter: "changeFilter"
  },
  decls: 47,
  vars: 36,
  consts: [[2, "display", "flex", "width", "100%", "justify-content", "space-between"], [1, "item-panel"], [2, "flex-direction", "row", "box-sizing", "border-box", "display", "flex", "place-content", "flex-start", "align-items", "flex-start"], ["type", "range", "min", "0", "max", "5", "step", "0.01", 1, "input-range", 3, "input", "ngModelChange", "ngStyle", "ngModel"], ["type", "range", "min", "0", "max", "1", "step", "0.01", 1, "input-range", 3, "input", "ngModelChange", "ngStyle", "ngModel"], ["type", "range", "min", "0", "max", "10", "step", "0.01", 1, "input-range", 3, "input", "ngModelChange", "ngStyle", "ngModel"], ["type", "range", "min", "0", "max", "20", "step", "1", 1, "input-range", 3, "input", "ngModelChange", "ngStyle", "ngModel"]],
  template: function BasicFiltersComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
      i0.ɵɵtext(2);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(3, "p", 1);
      i0.ɵɵtext(4);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(5, "div", 2)(6, "input", 3);
      i0.ɵɵlistener("input", function BasicFiltersComponent_Template_input_input_6_listener() {
        return ctx.onChange();
      });
      i0.ɵɵtwoWayListener("ngModelChange", function BasicFiltersComponent_Template_input_ngModelChange_6_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.state.contrast, $event) || (ctx.state.contrast = $event);
        return $event;
      });
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(7, "br");
      i0.ɵɵelementStart(8, "div", 0)(9, "p", 1);
      i0.ɵɵtext(10);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(11, "p", 1);
      i0.ɵɵtext(12);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(13, "div", 2)(14, "input", 3);
      i0.ɵɵlistener("input", function BasicFiltersComponent_Template_input_input_14_listener() {
        return ctx.onChange();
      });
      i0.ɵɵtwoWayListener("ngModelChange", function BasicFiltersComponent_Template_input_ngModelChange_14_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.state.brightness, $event) || (ctx.state.brightness = $event);
        return $event;
      });
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(15, "br");
      i0.ɵɵelementStart(16, "div", 0)(17, "p", 1);
      i0.ɵɵtext(18);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(19, "p", 1);
      i0.ɵɵtext(20);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(21, "div", 2)(22, "input", 4);
      i0.ɵɵlistener("input", function BasicFiltersComponent_Template_input_input_22_listener() {
        return ctx.onChange();
      });
      i0.ɵɵtwoWayListener("ngModelChange", function BasicFiltersComponent_Template_input_ngModelChange_22_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.state.grayscale, $event) || (ctx.state.grayscale = $event);
        return $event;
      });
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(23, "br");
      i0.ɵɵelementStart(24, "div", 0)(25, "p", 1);
      i0.ɵɵtext(26);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(27, "p", 1);
      i0.ɵɵtext(28);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(29, "div", 2)(30, "input", 5);
      i0.ɵɵlistener("input", function BasicFiltersComponent_Template_input_input_30_listener() {
        return ctx.onChange();
      });
      i0.ɵɵtwoWayListener("ngModelChange", function BasicFiltersComponent_Template_input_ngModelChange_30_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.state.saturate, $event) || (ctx.state.saturate = $event);
        return $event;
      });
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(31, "br");
      i0.ɵɵelementStart(32, "div", 0)(33, "p", 1);
      i0.ɵɵtext(34);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(35, "p", 1);
      i0.ɵɵtext(36);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(37, "div", 2)(38, "input", 4);
      i0.ɵɵlistener("input", function BasicFiltersComponent_Template_input_input_38_listener() {
        return ctx.onChange();
      });
      i0.ɵɵtwoWayListener("ngModelChange", function BasicFiltersComponent_Template_input_ngModelChange_38_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.state.sepia, $event) || (ctx.state.sepia = $event);
        return $event;
      });
      i0.ɵɵelementEnd()();
      i0.ɵɵelement(39, "br");
      i0.ɵɵelementStart(40, "div", 0)(41, "p", 1);
      i0.ɵɵtext(42);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(43, "p", 1);
      i0.ɵɵtext(44);
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(45, "div", 2)(46, "input", 6);
      i0.ɵɵlistener("input", function BasicFiltersComponent_Template_input_input_46_listener() {
        return ctx.onChange();
      });
      i0.ɵɵtwoWayListener("ngModelChange", function BasicFiltersComponent_Template_input_ngModelChange_46_listener($event) {
        i0.ɵɵtwoWayBindingSet(ctx.state.blur, $event) || (ctx.state.blur = $event);
        return $event;
      });
      i0.ɵɵelementEnd()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(ctx.labels["Contrast"]);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(((ctx.state == null ? null : ctx.state.contrast) || 0).toFixed(1));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(24, _c2, ctx.color));
      i0.ɵɵtwoWayProperty("ngModel", ctx.state.contrast);
      i0.ɵɵadvance(4);
      i0.ɵɵtextInterpolate(ctx.labels["Brightness"]);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(((ctx.state == null ? null : ctx.state.brightness) || 0).toFixed(1));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(26, _c2, ctx.color));
      i0.ɵɵtwoWayProperty("ngModel", ctx.state.brightness);
      i0.ɵɵadvance(4);
      i0.ɵɵtextInterpolate(ctx.labels["Grayscale"]);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(((ctx.state == null ? null : ctx.state.grayscale) || 0).toFixed(1));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(28, _c2, ctx.color));
      i0.ɵɵtwoWayProperty("ngModel", ctx.state.grayscale);
      i0.ɵɵadvance(4);
      i0.ɵɵtextInterpolate(ctx.labels["Saturate"]);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(((ctx.state == null ? null : ctx.state.saturate) || 0).toFixed(1));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(30, _c2, ctx.color));
      i0.ɵɵtwoWayProperty("ngModel", ctx.state.saturate);
      i0.ɵɵadvance(4);
      i0.ɵɵtextInterpolate(ctx.labels["Sepia"]);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(((ctx.state == null ? null : ctx.state.sepia) || 0).toFixed(1));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(32, _c2, ctx.color));
      i0.ɵɵtwoWayProperty("ngModel", ctx.state.sepia);
      i0.ɵɵadvance(4);
      i0.ɵɵtextInterpolate(ctx.labels["Blur"]);
      i0.ɵɵadvance(2);
      i0.ɵɵtextInterpolate(((ctx.state == null ? null : ctx.state.blur) || 0).toFixed(1));
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(34, _c2, ctx.color));
      i0.ɵɵtwoWayProperty("ngModel", ctx.state.blur);
    }
  },
  dependencies: [i4.RangeValueAccessor, i4.DefaultValueAccessor, i1.NgStyle, i4.NgControlStatus, i4.NgModel]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BasicFiltersComponent, [{
    type: Component,
    args: [{
      selector: 'lib-basic-filters',
      template: "<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Contrast'] }}</p>\n  <p class=\"item-panel\">{{ (this.state?.contrast || 0.0).toFixed(1) }}</p>\n</div>\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.contrast\"\n    type=\"range\"\n    min=\"0\"\n    max=\"5\"\n    step=\"0.01\"\n  />\n</div>\n\n<br />\n<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Brightness'] }}</p>\n  <p class=\"item-panel\">{{ (this.state?.brightness || 0.0).toFixed(1) }}</p>\n</div>\n\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.brightness\"\n    type=\"range\"\n    min=\"0\"\n    max=\"5\"\n    step=\"0.01\"\n  />\n</div>\n\n<br />\n<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Grayscale'] }}</p>\n  <p class=\"item-panel\">{{ (this.state?.grayscale || 0.0).toFixed(1) }}</p>\n</div>\n\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.grayscale\"\n    type=\"range\"\n    min=\"0\"\n    max=\"1\"\n    step=\"0.01\"\n  />\n</div>\n\n<br />\n<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Saturate'] }}</p>\n  <p class=\"item-panel\">{{ (this.state?.saturate || 0.0).toFixed(1) }}</p>\n</div>\n\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.saturate\"\n    type=\"range\"\n    min=\"0\"\n    max=\"10\"\n    step=\"0.01\"\n  />\n</div>\n<br />\n<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Sepia'] }}</p>\n  <p class=\"item-panel\">{{ (this.state?.sepia || 0.0).toFixed(1) }}</p>\n</div>\n\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.sepia\"\n    type=\"range\"\n    min=\"0\"\n    max=\"1\"\n    step=\"0.01\"\n  />\n</div>\n\n<!-- <br />\n<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Invert'] }}</p>\n  <p class=\"item-panel\">{{ (this.state?.invert || 0.0).toFixed(1) }}</p>\n</div>\n\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.invert\"\n    type=\"range\"\n    min=\"0\"\n    max=\"1\"\n    step=\"0.01\"\n  />\n</div> -->\n\n<br />\n<div style=\"display: flex; width: 100%; justify-content: space-between\">\n  <p class=\"item-panel\">{{ labels['Blur'] }}</p>\n  <p class=\"item-panel\">{{ (state?.blur || 0.0).toFixed(1) }}</p>\n</div>\n\n<div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n  <input\n    class=\"input-range\"\n    (input)=\"onChange()\"\n    [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n    [(ngModel)]=\"state.blur\"\n    type=\"range\"\n    min=\"0\"\n    max=\"20\"\n    step=\"1\"\n  />\n</div>\n",
      styles: [""]
    }]
  }], function () {
    return [];
  }, {
    color: [{
      type: Input
    }],
    labels: [{
      type: Input
    }],
    changeFilter: [{
      type: Output
    }],
    filterState: [{
      type: Input
    }]
  });
})();
class EditImageComponent {
  constructor(chRef) {
    this.chRef = chRef;
    this.controlPanelIndex = 0;
    this.showCrop = false;
    this.observer = null;
    this.allFormats = ['webp', 'jpeg', 'png'];
    this.initialState = {};
    this.state = {
      quality: 92,
      maxHeight: 1000,
      maxWidth: 1000,
      cropHeight: 150,
      cropWidth: 150,
      maintainAspectRatio: true,
      format: 'jpeg',
      arrayCopiedImages: [],
      originImageSrc: ''
    };
    this.closeModal = new EventEmitter();
  }
  ngOnInit() {
    this.state = JSON.parse(JSON.stringify({
      ...this.state,
      ...this.initialState
    }));
    // console.log(this.state);
  }
  onCloseEditPanel(saveChanges = false) {
    if (this.observer instanceof ResizeObserver) {
      this.observer.unobserve(document.getElementById('image-croper'));
      this.observer.unobserve(document.getElementById('image-full'));
    }
    this.showCrop = false;
    if (saveChanges) this.closeModal.next({
      state: this.state,
      imageSrc: this.imageSrc
    });else this.closeModal.next(null);
  }
  onControlPanelIndexChange(idex) {
    this.controlPanelIndex = idex;
  }
  calculateSize() {
    if (this.imageSrc && this.imageSrc.length) {
      return Math.ceil(3 / 4 * this.imageSrc.length / 1024);
    } else {
      return;
    }
  }
  async onChangeSize(changeHeight = false) {
    try {
      this.imageSrc = await convertImageUsingCanvas(this.state.originImageSrc, changeHeight, this.state);
      this.chRef.markForCheck();
    } catch (error) {
      console.log('🚀 ~ file: edit-image.component.ts ~ line 76 ~ EditImageComponent ~ onChangeSize ~ error', error);
      this.chRef.markForCheck();
    }
  }
  async onChangeQuality() {
    try {
      this.imageSrc = await convertImageUsingCanvas(this.state.originImageSrc, false, this.state);
      this.chRef.markForCheck();
    } catch (error) {
      console.log('🚀 ~ file: edit-image.component.ts ~ line 86 ~ EditImageComponent ~ onChangeQuality ~ error', error);
      this.chRef.markForCheck();
    }
  }
  async onChangeFormat() {
    try {
      this.imageSrc = await convertImageUsingCanvas(this.state.originImageSrc, false, this.state);
      this.chRef.markForCheck();
    } catch (error) {
      console.log('🚀 ~ file: edit-image.component.ts ~ line 98 ~ EditImageComponent ~ onChangeFormat ~ error', error);
      this.chRef.markForCheck();
    }
  }
  async onRestore() {
    try {
      if (this.state.arrayCopiedImages.length > 1) {
        this.state.arrayCopiedImages.pop();
        let newValue = this.state.arrayCopiedImages[this.state.arrayCopiedImages.length - 1];
        this.state = {
          ...this.state,
          maxHeight: newValue.height,
          maxWidth: newValue.width,
          quality: newValue.quality,
          format: newValue.format,
          originImageSrc: newValue.originImageSrc,
          basicFilters: newValue.basicFilters
        };
        this.imageSrc = newValue.lastImage;
        this.chRef.markForCheck();
      }
    } catch (e) {
      console.log('🚀 ~ file: edit-image.component.ts ~ line 126 ~ EditImageComponent ~ onRestore ~ e', e);
    }
  }
  onCropStateChange() {
    const croper = document.getElementById('image-croper');
    if (this.showCrop) {
      croper.style.opacity = '1.0';
      dragElement(croper);
      this.observer = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const elemntCropper = document.getElementById('image-croper');
          const rectHolder = document.getElementById('image-full').getBoundingClientRect();
          const rectElemnt = elemntCropper.getBoundingClientRect();
          const maxWidth = rectHolder.x + rectHolder.width - rectElemnt.x - 1;
          const maxHeight = rectHolder.y + rectHolder.height - rectElemnt.y - 1;
          elemntCropper.style.maxWidth = maxWidth + 'px';
          elemntCropper.style.maxHeight = maxHeight + 'px';
          this.state.cropWidth = rectElemnt.width;
          this.state.cropHeight = rectElemnt.height;
          if (entry.target.id == 'image-full') {
            if (rectHolder.top > 0) {
              elemntCropper.style.top = rectHolder.top + 1 + 'px';
            }
            elemntCropper.style.left = rectHolder.left + 1 + 'px';
          }
        });
      });
      this.observer.observe(document.getElementById('image-croper'));
      this.observer.observe(document.getElementById('image-full'));
      this.chRef.markForCheck();
    } else {
      croper.style.opacity = '0.0';
      if (this.observer instanceof ResizeObserver) {
        this.observer.unobserve(document.getElementById('image-croper'));
        this.observer.unobserve(document.getElementById('image-full'));
      }
      this.chRef.markForCheck();
    }
  }
  onChangeCrop() {
    const croper = document.getElementById('image-croper');
    croper.style.width = this.state.cropWidth + 'px';
    croper.style.height = this.state.cropHeight + 'px';
  }
  onCrop() {
    const croper = document.getElementById('image-croper');
    const rectCroper = croper.getBoundingClientRect();
    const dataHolderRect = document.getElementById('image-full').getBoundingClientRect();
    const canvas = document.createElement('canvas');
    return new Promise((resolve, reject) => {
      let ctx = canvas.getContext('2d');
      let image = new Image();
      image.src = this.imageSrc;
      image.onload = () => {
        let ratio = image.height / dataHolderRect.height;
        let newWidth = rectCroper.width * ratio;
        let newHeight = rectCroper.height * ratio;
        canvas.height = newHeight;
        canvas.width = newWidth;
        ctx.drawImage(image, Math.abs(rectCroper.x * ratio) - Math.abs(dataHolderRect.x * ratio), Math.abs(rectCroper.y * ratio) - Math.abs(dataHolderRect.y * ratio), newWidth, newHeight, 0, 0, newWidth, newHeight);
        return resolve(canvas.toDataURL(`image/${this.state.format}`, this.state.quality));
      };
      image.onerror = e => {
        reject(e);
      };
    }).then(dataUri => {
      this.imageSrc = dataUri;
      this.showCrop = false;
      this.onCropStateChange();
      this.state.maxWidth = canvas.width;
      this.state.maxHeight = canvas.height;
      this.state.originImageSrc = dataUri;
      if (this.state.arrayCopiedImages.length <= MAX_BUFFER_UNDO_MEMORY) {
        this.state.arrayCopiedImages.push({
          lastImage: dataUri,
          width: this.state.maxWidth,
          height: this.state.maxHeight,
          quality: this.state.quality,
          format: this.state.format,
          originImageSrc: this.state.originImageSrc,
          basicFilters: this.state.basicFilters
        });
      } else {
        this.state.arrayCopiedImages[this.state.arrayCopiedImages.length - 1] = {
          lastImage: dataUri,
          width: this.state.maxWidth,
          height: this.state.maxHeight,
          quality: this.state.quality,
          format: this.state.format,
          originImageSrc: this.state.originImageSrc,
          basicFilters: this.state.basicFilters
        };
      }
      this.chRef.markForCheck();
    }).catch(e => {
      console.log(e);
    });
  }
  async onChangeFilters(data) {
    try {
      if (!this.state.basicFilters) {
        this.state.basicFilters = data;
      } else {
        this.state.basicFilters = {
          ...this.state.basicFilters,
          ...data
        };
      }
      this.imageSrc = await convertImageUsingCanvas(this.state.originImageSrc, false, this.state);
      this.chRef.markForCheck();
    } catch (e) {
      console.log('🚀 ~ file: edit-image.component.ts ~ line 250 ~ EditImageComponent ~ onChangeFilters ~ e', e);
    }
  }
}
EditImageComponent.ɵfac = function EditImageComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || EditImageComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
};
EditImageComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: EditImageComponent,
  selectors: [["lib-edit-image"]],
  inputs: {
    labels: "labels",
    imageSrc: "imageSrc",
    color: "color",
    initialState: "initialState"
  },
  outputs: {
    closeModal: "closeModal"
  },
  decls: 25,
  vars: 13,
  consts: [["id", "popup", 1, "popup"], [2, "flex-direction", "row", "box-sizing", "border-box", "display", "flex", "place-content", "center flex-end", "align-items", "center"], [1, "icon-btn", 3, "click"], [1, "material-icons"], [1, "image-container"], [1, "image-holder-full"], ["id", "image-full", 3, "src"], ["id", "image-croper", 1, "image-croper"], [1, "grid"], ["id", "image-croper-header"], ["style", "border: 1px dashed #fafafa; flex: 0 1 32%; width: 33%; height: 33%; background-color: rgba(0, 0, 0, 0.48)", 4, "ngFor", "ngForOf"], [1, "material-icons", 2, "position", "absolute", "top", "0", "left", "0"], [1, "control-panel"], [3, "indexActivatedChange", "color", "_labels"], [4, "ngIf"], [1, "icon-btn", 2, "position", "absolute", "right", "10px", "top", "30px", 3, "click", "disabled"], [2, "flex-direction", "row", "box-sizing", "border-box", "display", "flex", "place-content", "center space-between", "align-items", "center", "margin-top", "8px"], [1, "save-btn", 3, "click"], ["class", "caption image-caption", 3, "ngStyle", 4, "ngIf"], [2, "border", "1px dashed #fafafa", "flex", "0 1 32%", "width", "33%", "height", "33%", "background-color", "rgba(0, 0, 0, 0.48)"], [2, "display", "flex", "width", "100%", "justify-content", "space-between"], [1, "item-panel"], [2, "flex-direction", "row", "box-sizing", "border-box", "display", "flex", "place-content", "flex-start", "align-items", "flex-start"], ["type", "range", "min", "1", "max", "100", "value", "50", 1, "input-range", 3, "change", "ngModelChange", "readonly", "disabled", "ngStyle", "ngModel"], [1, "item-panel", 2, "display", "flex", "width", "100%", "justify-content", "space-between"], [2, "display", "flex", "align-items", "center"], ["type", "checkbox", 3, "ngModelChange", "ngModel"], [1, "caption"], [2, "margin-top", "8px !important", "flex-flow", "row wrap", "box-sizing", "border-box", "display", "flex", "place-content", "flex-start space-between", "align-items", "flex-start"], [1, "form-field", 2, "max-width", "48%", "width", "48%"], ["type", "number", 3, "change", "ngModelChange", "readonly", "disabled", "placeholder", "ngModel", "min", "max"], [2, "margin-top", "8px !important", "flex-direction", "row", "box-sizing", "border-box", "display", "flex", "place-content", "flex-start", "align-items", "flex-start"], [1, "form-field", 2, "width", "100%"], [3, "ngModelChange", "change", "disabled", "ngModel"], [3, "value", 4, "ngFor", "ngForOf"], [2, "display", "flex", "justify-content", "space-between", "margin-bottom", "8px"], ["type", "checkbox", 3, "change", "ngModelChange", "ngModel"], [3, "value"], [1, "form-field", 2, "max-width", "48%", "width", "48%", "margin-bottom", "8px"], ["type", "number", 3, "change", "ngModelChange", "placeholder", "ngModel", "min", "max"], [2, "margin-bottom", "4px !important"], ["title", "Cut the image", 1, "icon-btn", 3, "click"], [3, "changeFilter", "filterState", "labels", "color"], [1, "caption", "image-caption", 3, "ngStyle"]],
  template: function EditImageComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "button", 2);
      i0.ɵɵlistener("click", function EditImageComponent_Template_button_click_2_listener() {
        return ctx.onCloseEditPanel(false);
      });
      i0.ɵɵelementStart(3, "span", 3);
      i0.ɵɵtext(4, "clear");
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
      i0.ɵɵelement(7, "img", 6);
      i0.ɵɵelementStart(8, "div", 7);
      i0.ɵɵelement(9, "div", 8);
      i0.ɵɵelementStart(10, "div", 9);
      i0.ɵɵtemplate(11, EditImageComponent_div_11_Template, 1, 0, "div", 10);
      i0.ɵɵelementStart(12, "span", 11);
      i0.ɵɵtext(13, "drag_indicator");
      i0.ɵɵelementEnd()()()();
      i0.ɵɵelementStart(14, "div", 12)(15, "lib-tabs", 13);
      i0.ɵɵlistener("indexActivatedChange", function EditImageComponent_Template_lib_tabs_indexActivatedChange_15_listener($event) {
        return ctx.onControlPanelIndexChange($event);
      });
      i0.ɵɵtemplate(16, EditImageComponent_ng_container_16_Template, 35, 36, "ng-container", 14)(17, EditImageComponent_ng_container_17_Template, 2, 3, "ng-container", 14);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(18, "button", 15);
      i0.ɵɵlistener("click", function EditImageComponent_Template_button_click_18_listener() {
        return ctx.onRestore();
      });
      i0.ɵɵelementStart(19, "span", 3);
      i0.ɵɵtext(20, " refresh ");
      i0.ɵɵelementEnd()();
      i0.ɵɵelementStart(21, "div", 16)(22, "button", 17);
      i0.ɵɵlistener("click", function EditImageComponent_Template_button_click_22_listener() {
        return ctx.onCloseEditPanel(true);
      });
      i0.ɵɵtext(23);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(24, EditImageComponent_p_24_Template, 2, 6, "p", 18);
      i0.ɵɵelementEnd()()()();
    }
    if (rf & 2) {
      i0.ɵɵadvance(7);
      i0.ɵɵproperty("src", ctx.imageSrc, i0.ɵɵsanitizeUrl);
      i0.ɵɵadvance();
      i0.ɵɵstyleProp("display", ctx.showCrop ? "" : "none");
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(11, _c3));
      i0.ɵɵadvance(4);
      i0.ɵɵproperty("color", ctx.color)("_labels", i0.ɵɵpureFunction0(12, _c4));
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.controlPanelIndex == 0);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.controlPanelIndex == 1);
      i0.ɵɵadvance();
      i0.ɵɵproperty("disabled", ctx.state.arrayCopiedImages.length <= 1);
      i0.ɵɵadvance(5);
      i0.ɵɵtextInterpolate(ctx.labels["Save"]);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.calculateSize());
    }
  },
  dependencies: [TabsComponent, BasicFiltersComponent, i1.NgForOf, i1.NgIf, i4.RangeValueAccessor, i4.DefaultValueAccessor, i1.NgStyle, i4.NgControlStatus, i4.NgModel, i4.CheckboxControlValueAccessor, i4.NumberValueAccessor, i4.MinValidator, i4.MaxValidator, i4.SelectControlValueAccessor, i4.NgSelectOption, i4.ɵNgSelectMultipleOption],
  styles: [".popup[_ngcontent-%COMP%]{width:100vw;max-height:100%;height:100%;overflow:auto;position:fixed;top:0;left:0;background-color:#000c;z-index:1000;padding:24px;color:#fff;box-sizing:border-box;animation-name:show;animation-duration:.4s}.popup[_ngcontent-%COMP%]   .image-container[_ngcontent-%COMP%]{margin-top:50px;margin-bottom:50px;width:100%;flex-flow:row wrap;box-sizing:border-box;display:flex;place-content:flex-start center;align-items:flex-start}.popup[_ngcontent-%COMP%]   .image-container[_ngcontent-%COMP%]   .image-holder-full[_ngcontent-%COMP%]{height:auto;width:auto;position:relative;display:contents}.popup[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{color:#fff}.popup[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:600px;max-width:100%;object-fit:cover;object-position:center;margin:8px;transition:all .5s ease}@media (max-width: 1024px){.popup[_ngcontent-%COMP%]{background-color:#000000d9;padding:8px}.popup[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-height:100%;max-width:100%}}@media (max-width: 599px){.popup[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:0}}.popup[_ngcontent-%COMP%]   .control-panel[_ngcontent-%COMP%]{color:#fff;background-color:#000000eb;margin:8px;padding:16px;width:18rem;border-radius:8px;flex-direction:column;box-sizing:border-box;display:flex;place-content:stretch flex-start;align-items:stretch;max-width:100%;position:relative}@media (max-width: 599px){.popup[_ngcontent-%COMP%]   .control-panel[_ngcontent-%COMP%]{margin:8px 0;width:100%}}.popup[_ngcontent-%COMP%]   .control-panel[_ngcontent-%COMP%]   .title-panel[_ngcontent-%COMP%]{padding:0 4px;font-size:17px;font-weight:500;margin-bottom:16px!important}.popup[_ngcontent-%COMP%]   .control-panel[_ngcontent-%COMP%]   .item-panel[_ngcontent-%COMP%]{padding:0;font-size:14px;font-weight:500}.image-croper[_ngcontent-%COMP%]{position:absolute;width:180px;height:180px;border:2.5px solid #fafafa;box-sizing:border-box;resize:both;overflow:auto;opacity:0;border-radius:4px;overflow:hidden;z-index:10}.image-croper[_ngcontent-%COMP%]   #image-croper-header[_ngcontent-%COMP%]{padding:0;cursor:move;z-index:9;background-color:transparent;color:#fff;height:100%;display:flex;flex-wrap:wrap;width:100%;box-sizing:border-box;position:absolute;top:50%;transform:translateY(-50%);opacity:.8}.image-croper[_ngcontent-%COMP%]   #image-croper-header[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{color:#fff}.input-range[_ngcontent-%COMP%]{margin-bottom:16px;margin-top:4px}input[type=checkbox][_ngcontent-%COMP%]{cursor:pointer}.form-field[_ngcontent-%COMP%]{margin-bottom:16px}.form-field[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:12px;opacity:.92;margin-bottom:4px;display:block}.form-field[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{height:34px;width:100%;box-sizing:border-box;border-radius:4px;border:none;padding:2px 8px;outline:none}.form-field[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{height:34px;width:100%;box-sizing:border-box;border-radius:4px;border:none;padding:2px 8px;outline:none;background-color:#fff}.save-btn[_ngcontent-%COMP%]{padding:0 8px;height:34px;box-sizing:border-box;background-color:#fff;color:#000;border:none;border-radius:4px;cursor:pointer}.save-btn[_ngcontent-%COMP%]:active{transform:scale(.95)}"]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EditImageComponent, [{
    type: Component,
    args: [{
      selector: 'lib-edit-image',
      template: "<div id=\"popup\" class=\"popup\">\n  <div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: center flex-end; align-items: center\">\n    <button class=\"icon-btn\" (click)=\"onCloseEditPanel(false)\">\n      <span class=\"material-icons\">clear</span>\n    </button>\n  </div>\n\n  <div class=\"image-container\">\n    <div class=\"image-holder-full\">\n      <img id=\"image-full\" [src]=\"this.imageSrc\" />\n\n      <div id=\"image-croper\" class=\"image-croper\" [style.display]=\"showCrop ? '' : 'none'\">\n        <div class=\"grid\"></div>\n        <div id=\"image-croper-header\">\n          <div\n            *ngFor=\"let item of [1, 2, 3, 4, 5, 6, 7, 8, 9]\"\n            style=\"border: 1px dashed #fafafa; flex: 0 1 32%; width: 33%; height: 33%; background-color: rgba(0, 0, 0, 0.48)\"\n          ></div>\n          <span class=\"material-icons\" style=\"position: absolute; top: 0; left: 0\">drag_indicator</span>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"control-panel\">\n      <lib-tabs [color]=\"this.color\" [_labels]=\"['Basic', 'Filters']\" (indexActivatedChange)=\"onControlPanelIndexChange($event)\">\n        <ng-container *ngIf=\"controlPanelIndex == 0\">\n          <div style=\"display: flex; width: 100%; justify-content: space-between\">\n            <p class=\"item-panel\">{{ labels['Quality'] }}</p>\n            <p class=\"item-panel\">{{ this.state.quality + '%' }}</p>\n          </div>\n\n          <div style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\">\n            <input\n              [readonly]=\"showCrop\"\n              [disabled]=\"showCrop\"\n              class=\"input-range\"\n              (change)=\"onChangeQuality()\"\n              [ngStyle]=\"{ maxWidth: '100%', width: '100%', color: color }\"\n              [(ngModel)]=\"this.state.quality\"\n              type=\"range\"\n              min=\"1\"\n              max=\"100\"\n              value=\"50\"\n            />\n          </div>\n\n          <div class=\"item-panel\" style=\"display: flex; width: 100%; justify-content: space-between\">\n            {{ labels['Max dimensions'] }}\n            <div style=\"display: flex; align-items: center\">\n              <input type=\"checkbox\" [(ngModel)]=\"this.state.maintainAspectRatio\" [style.color]=\"color\" />\n              <span class=\"caption\">{{ labels['aspect-ratio'] }}</span>\n            </div>\n          </div>\n\n          <div\n            style=\"\n              margin-top: 8px !important;\n              flex-flow: row wrap;\n              box-sizing: border-box;\n              display: flex;\n              place-content: flex-start space-between;\n              align-items: flex-start;\n            \"\n          >\n            <div class=\"form-field\" style=\"max-width: 48%; width: 48%\">\n              <label>{{ labels['max-width(px)'] }}</label>\n              <input\n                [readonly]=\"showCrop\"\n                [disabled]=\"showCrop\"\n                (change)=\"onChangeSize(false)\"\n                placeholder=\"{{ labels['max-width(px)'] }}\"\n                [(ngModel)]=\"this.state.maxWidth\"\n                type=\"number\"\n                [min]=\"0\"\n                [max]=\"2000\"\n              />\n            </div>\n\n            <div class=\"form-field\" style=\"max-width: 48%; width: 48%\">\n              <label>{{ labels['max-height(px)'] }}</label>\n              <input\n                [readonly]=\"showCrop\"\n                [disabled]=\"showCrop\"\n                (change)=\"onChangeSize(true)\"\n                placeholder=\"{{ labels['max-height(px)'] }}\"\n                [(ngModel)]=\"this.state.maxHeight\"\n                type=\"number\"\n                [min]=\"0\"\n                [max]=\"2000\"\n              />\n            </div>\n          </div>\n\n          <p class=\"item-panel\">{{ labels['Format'] }}</p>\n          <div\n            style=\"\n              margin-top: 8px !important;\n              flex-direction: row;\n              box-sizing: border-box;\n              display: flex;\n              place-content: flex-start;\n              align-items: flex-start;\n            \"\n          >\n            <div class=\"form-field\" style=\"width: 100%\">\n              <select [disabled]=\"showCrop\" [(ngModel)]=\"this.state.format\" (change)=\"onChangeFormat()\">\n                <option *ngFor=\"let formatItem of allFormats\" [value]=\"formatItem\">{{ formatItem }}</option>\n              </select>\n            </div>\n          </div>\n          <div style=\"display: flex; justify-content: space-between; margin-bottom: 8px\">\n            <span style=\"display: flex; align-items: center\">\n              <input type=\"checkbox\" (change)=\"onCropStateChange()\" [(ngModel)]=\"showCrop\" [style.color]=\"color\" />\n              <span class=\"item-panel\">{{ labels['Crop'] }}</span>\n            </span>\n          </div>\n\n          <ng-container *ngIf=\"showCrop\">\n            <div\n              style=\"\n                margin-top: 8px !important;\n                flex-flow: row wrap;\n                box-sizing: border-box;\n                display: flex;\n                place-content: flex-start space-between;\n                align-items: flex-start;\n              \"\n            >\n              <div class=\"form-field\" style=\"max-width: 48%; width: 48%; margin-bottom: 8px\">\n                <label>{{ labels['width(px)'] }}</label>\n                <input\n                  (change)=\"onChangeCrop()\"\n                  placeholder=\"{{ labels['width(px)'] }}\"\n                  [(ngModel)]=\"this.state.cropWidth\"\n                  type=\"number\"\n                  [min]=\"0\"\n                  [max]=\"2000\"\n                />\n              </div>\n              <div class=\"form-field\" style=\"max-width: 48%; width: 48%; margin-bottom: 8px\">\n                <label>{{ labels['height(px)'] }}</label>\n                <input\n                  (change)=\"onChangeCrop()\"\n                  placeholder=\"{{ labels['height(px)'] }}\"\n                  [(ngModel)]=\"this.state.cropHeight\"\n                  type=\"number\"\n                  [min]=\"0\"\n                  [max]=\"2000\"\n                />\n              </div>\n            </div>\n\n            <p style=\"margin-bottom: 4px !important\">\n              <button title=\"Cut the image\" class=\"icon-btn\" (click)=\"onCrop()\">\n                <span class=\"material-icons\"> crop </span>\n              </button>\n            </p>\n          </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"controlPanelIndex == 1\">\n          <lib-basic-filters\n            [filterState]=\"this.state.basicFilters\"\n            (changeFilter)=\"onChangeFilters($event)\"\n            [labels]=\"this.labels\"\n            [color]=\"this.color\"\n          ></lib-basic-filters>\n        </ng-container>\n      </lib-tabs>\n\n      <button\n        [disabled]=\"this.state.arrayCopiedImages.length <= 1\"\n        style=\"position: absolute; right: 10px; top: 30px\"\n        class=\"icon-btn\"\n        (click)=\"onRestore()\"\n      >\n        <span class=\"material-icons\"> refresh </span>\n      </button>\n      <div\n        style=\"\n          flex-direction: row;\n          box-sizing: border-box;\n          display: flex;\n          place-content: center space-between;\n          align-items: center;\n          margin-top: 8px;\n        \"\n      >\n        <button class=\"save-btn\" (click)=\"onCloseEditPanel(true)\">{{ labels['Save'] }}</button>\n\n        <p\n          *ngIf=\"this.calculateSize()\"\n          class=\"caption image-caption\"\n          [ngStyle]=\"{\n            color: this.calculateSize() > 120 ? '#f44336' : 'unset',\n            fontWeight: this.calculateSize() > 120 ? '500' : 'unset'\n          }\"\n        >\n          size: {{ this.calculateSize() }}Kb &nbsp; {{ this.format }}\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n",
      styles: [".popup{width:100vw;max-height:100%;height:100%;overflow:auto;position:fixed;top:0;left:0;background-color:#000c;z-index:1000;padding:24px;color:#fff;box-sizing:border-box;animation-name:show;animation-duration:.4s}.popup .image-container{margin-top:50px;margin-bottom:50px;width:100%;flex-flow:row wrap;box-sizing:border-box;display:flex;place-content:flex-start center;align-items:flex-start}.popup .image-container .image-holder-full{height:auto;width:auto;position:relative;display:contents}.popup .material-icons{color:#fff}.popup img{max-height:600px;max-width:100%;object-fit:cover;object-position:center;margin:8px;transition:all .5s ease}@media (max-width: 1024px){.popup{background-color:#000000d9;padding:8px}.popup img{max-height:100%;max-width:100%}}@media (max-width: 599px){.popup img{margin:0}}.popup .control-panel{color:#fff;background-color:#000000eb;margin:8px;padding:16px;width:18rem;border-radius:8px;flex-direction:column;box-sizing:border-box;display:flex;place-content:stretch flex-start;align-items:stretch;max-width:100%;position:relative}@media (max-width: 599px){.popup .control-panel{margin:8px 0;width:100%}}.popup .control-panel .title-panel{padding:0 4px;font-size:17px;font-weight:500;margin-bottom:16px!important}.popup .control-panel .item-panel{padding:0;font-size:14px;font-weight:500}.image-croper{position:absolute;width:180px;height:180px;border:2.5px solid #fafafa;box-sizing:border-box;resize:both;overflow:auto;opacity:0;border-radius:4px;overflow:hidden;z-index:10}.image-croper #image-croper-header{padding:0;cursor:move;z-index:9;background-color:transparent;color:#fff;height:100%;display:flex;flex-wrap:wrap;width:100%;box-sizing:border-box;position:absolute;top:50%;transform:translateY(-50%);opacity:.8}.image-croper #image-croper-header .material-icons{color:#fff}.input-range{margin-bottom:16px;margin-top:4px}input[type=checkbox]{cursor:pointer}.form-field{margin-bottom:16px}.form-field label{font-size:12px;opacity:.92;margin-bottom:4px;display:block}.form-field input{height:34px;width:100%;box-sizing:border-box;border-radius:4px;border:none;padding:2px 8px;outline:none}.form-field select{height:34px;width:100%;box-sizing:border-box;border-radius:4px;border:none;padding:2px 8px;outline:none;background-color:#fff}.save-btn{padding:0 8px;height:34px;box-sizing:border-box;background-color:#fff;color:#000;border:none;border-radius:4px;cursor:pointer}.save-btn:active{transform:scale(.95)}\n"]
    }]
  }], function () {
    return [{
      type: i0.ChangeDetectorRef
    }];
  }, {
    labels: [{
      type: Input
    }],
    imageSrc: [{
      type: Input
    }],
    color: [{
      type: Input
    }],
    initialState: [{
      type: Input
    }],
    closeModal: [{
      type: Output
    }]
  });
})();
class NgpImagePickerComponent {
  constructor(chRef) {
    this.chRef = chRef;
    this.config = {
      height: '240px',
      width: '320px',
      borderRadius: '16px',
      language: 'en',
      hideDeleteBtn: false,
      hideDownloadBtn: false,
      hideEditBtn: false,
      hideAddBtn: false
    };
    this.state = {
      quality: 92,
      maxHeight: 1000,
      maxWidth: 1000,
      cropHeight: 150,
      cropWidth: 150,
      maintainAspectRatio: true,
      format: 'jpeg',
      arrayCopiedImages: [],
      originImageSrc: ''
    };
    this.loadImage = false;
    this.uuidFilePicker = Date.now().toString(20);
    this.showEditPanel = false;
    this.imageName = 'donload';
    ///////////////////////////////////////////////////////
    this.labelEn = {
      'Upload a image': 'Upload a image',
      'You must edit the image in order to resize it': 'You must edit the image in order to resize it',
      'too large': 'too large',
      'Open the editor panel': 'Open the editor panel',
      'Download the image': 'Download the image',
      'Control Panel': 'Control Panel',
      Quality: 'Quality',
      'Max dimensions': 'Max dimensions',
      'aspect-ratio': 'aspect-ratio',
      'max-width(px)': 'max-width(px)',
      'max-height(px)': 'max-height(px)',
      Format: 'Format',
      Crop: 'Crop',
      'width(px)': 'width(px)',
      'height(px)': 'height(px)',
      Remove: 'Remove',
      Save: 'Save',
      Contrast: 'Contrast',
      Blur: 'Blur',
      Brightness: 'Brightness',
      Grayscale: 'Grayscale',
      Saturate: 'Saturate',
      Sepia: 'Sepia'
    };
    this.labelEs = {
      'Upload a image': 'Suba una imagen',
      'You must edit the image in order to resize it': 'Debe editar la imagen para disminuir su tamaño',
      'too large': 'muy grande',
      'Open the editor panel': 'Abra el panel de edición',
      'Download the image': 'Descarge la imagen',
      'Control Panel': 'Panel de control',
      Remove: 'Quitar',
      Quality: 'Calidad',
      'Max dimensions': 'Dimensiones',
      'aspect-ratio': 'relación-aspecto',
      'max-width(px)': 'max. ancho',
      'max-height(px)': 'max. alto',
      Format: 'Formato',
      Crop: 'Recortar',
      'width(px)': 'ancho(px)',
      'height(px)': 'altura(px)',
      Save: 'Guardar',
      Contrast: 'Contraste',
      Blur: 'Blur',
      Brightness: 'Brillo',
      Grayscale: 'Scala de gris',
      Saturate: 'Saturación',
      Sepia: 'Sepia'
    };
    this.labelFr = {
      'Upload a image': 'Charger une image',
      'You must edit the image in order to resize it': "Vous devez éditer l'image pour changer sa taille",
      'too large': 'Trop grande',
      'Open the editor panel': "Ouvrir le panneau d'édition",
      'Download the image': "Télécharger l'image",
      'Control Panel': 'Panneau de commande',
      Remove: 'Supprimer',
      Quality: 'Qualité',
      'Max dimensions': 'Dimensions maximales',
      'aspect-ratio': 'rapport de forme',
      'max-width(px)': 'largeur max.',
      'max-height(px)': 'hauteur max',
      Format: 'Format',
      Crop: 'Recadrer',
      'width(px)': 'largeur(px)',
      'height(px)': 'hauteur(px)',
      Save: 'Sauvez',
      Contrast: 'Contraste',
      Blur: 'Blur',
      Brightness: 'Luminosité',
      Grayscale: 'Grayscale',
      Saturate: 'Saturer',
      Sepia: 'Seiche'
    };
    this.labelDe = {
      'Upload a image': 'Bild hochladen',
      'You must edit the image in order to resize it': 'Sie müssen das Bild bearbeiten, um seine Größe zu ändern',
      'too large': 'zu groß',
      'Open the editor panel': 'Editor-Fenster öffnen',
      'Download the image': 'Bild herunterladen',
      'Control Panel': 'Bedienfeld',
      Quality: 'Qualität',
      'Max dimensions': 'Maximale Größe',
      'aspect-ratio': 'Seitenverhältnis',
      'max-width(px)': 'Max. Breite(px)',
      'max-height(px)': 'Max. Höhe(px)',
      Format: 'Format',
      Crop: 'Zuschneiden',
      'width(px)': 'Breite(px)',
      'height(px)': 'Höhe(px)',
      Remove: 'Entfernen',
      Save: 'Speichern',
      Contrast: 'Kontrast',
      Blur: 'Blur',
      Brightness: 'Helligkeit',
      Grayscale: 'Graustufen',
      Saturer: 'Sättigen',
      Sepia: 'Tintenfisch'
    };
    this.labels = this.labelEn;
    this.arrayCopiedImages = [];
    this.color = '#1e88e5';
    this.$imageChanged = new EventEmitter();
    this.$imageOriginal = new EventEmitter();
  }
  set _imageSrc(value) {
    if (value != undefined) {
      this.parseToBase64(value).then(dataUri => {
        this.imageSrc = dataUri;
        this.state.originImageSrc = value;
        this.state.arrayCopiedImages.push({
          lastImage: dataUri,
          width: this.state.maxWidth,
          height: this.state.maxHeight,
          quality: this.state.quality,
          format: this.state.format,
          originImageSrc: value
        });
        this.$imageOriginal.next(this.state.originImageSrc);
        this.loadImage = true;
        this.chRef.markForCheck();
      });
    } else {
      this.imageSrc = null;
      this.state.originImageSrc = null;
      this.loadImage = false;
      this.state.arrayCopiedImages = [];
      this.$imageOriginal.next(null);
      this.state = {
        ...this.state,
        format: 'jpeg',
        maxHeight: 1000,
        maxWidth: 1000,
        cropHeight: 150,
        cropWidth: 150,
        maintainAspectRatio: true
      };
      this.showEditPanel = false;
      this.chRef.markForCheck();
    }
  }
  set _config(value) {
    this.processConfig(value);
  }
  ngOnInit() {
    this.appendLinkIconsToHead();
  }
  appendLinkIconsToHead() {
    let head = document.head;
    let linkIcons = head.querySelector('#ngp-image-picker-icons-id');
    if (linkIcons) return;
    let link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
    link.rel = 'stylesheet';
    link.id = 'ngp-image-picker-icons-id';
    head.appendChild(link);
  }
  onUpload(event) {
    event.preventDefault();
    this.imagePicker.nativeElement.click();
  }
  handleFileSelect(evt) {
    const files = evt.target?.files;
    if (files) {
      const file = files[0];
      this.imageName = file.name.split('.')[0];
      this.fileType = file.type;
      if (!this.fileType.includes('image')) return;
      this.urlImage = `data:${file.type};base64,`;
      if (file) {
        this.state.format = this.fileType.split('image/')[1];
        const reader = new FileReader();
        reader.onload = this.handleReaderLoaded.bind(this);
        reader.readAsBinaryString(file);
      }
    }
  }
  async handleReaderLoaded(readerEvt) {
    const binaryString = readerEvt.target.result;
    const base64textString = btoa(binaryString);
    this.state.originImageSrc = this.urlImage + base64textString;
    if (this.config.compressInitial) {
      this.state = {
        ...this.state,
        quality: Math.min(this.config.compressInitial || 92, 100),
        maintainAspectRatio: true
      };
      this.imageSrc = await convertImageUsingCanvas(this.urlImage + base64textString, false, this.state, {
        getDimFromImage: true
      });
    } else {
      this.imageSrc = this.urlImage + base64textString;
      let img = document.createElement('img');
      img.src = this.imageSrc;
      img.onload = () => {
        this.state.arrayCopiedImages = [];
        this.state.maxHeight = img.height;
        this.state.maxWidth = img.width;
        this.state.arrayCopiedImages.push({
          lastImage: this.imageSrc,
          width: img.width,
          height: img.height,
          quality: this.state.quality,
          format: this.state.format,
          originImageSrc: this.state.originImageSrc
        });
      };
    }
    this.$imageChanged.next(this.imageSrc);
    this.loadImage = true;
    this.chRef.markForCheck();
  }
  onOpenEditPanel() {
    this.showEditPanel = true;
  }
  onCloseEditPanel(data) {
    if (data) {
      this.state = data.state;
      this.imageSrc = data.imageSrc;
      this.$imageChanged.next(this.imageSrc);
    }
    this.showEditPanel = false;
  }
  parseToBase64(imageUrl) {
    let types = imageUrl.split('.');
    let type = types[types.length - 1];
    if (type && (type == 'png' || type == 'jpeg' || type == 'webp')) {
      type = type;
    } else {
      type = 'jpeg';
    }
    this.state = {
      ...this.state,
      format: type
    };
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      this.state = {
        ...this.state,
        maxHeight: img.height,
        maxWidth: img.width
      };
      img.onload = () => {
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        let ratio = 1.0;
        canvas.width = img.width * ratio;
        canvas.height = img.height * ratio;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        let dataURI = canvas.toDataURL(`image/${type}`, this.state.quality);
        return resolve({
          dataUri: dataURI,
          width: canvas.width,
          height: canvas.height
        });
      };
      img.src = imageUrl;
    }).then(data => {
      this.state = {
        ...this.state,
        maxHeight: data.height,
        maxWidth: data.width
      };
      return data.dataUri;
    });
  }
  processConfig(value) {
    if (value && value.constructor == Object) {
      this.config = {
        ...this.config,
        ...value
      };
      if (value.language != undefined) {
        if (value.language == 'en') {
          this.labels = {
            ...this.labelEn
          };
        }
        if (value.language == 'es') {
          this.labels = {
            ...this.labelEs
          };
        }
        if (value.language == 'fr') {
          this.labels = {
            ...this.labelFr
          };
        }
        if (value.language == 'de') {
          this.labels = {
            ...this.labelDe
          };
        }
      }
    }
  }
  calculateSize() {
    if (this.imageSrc && this.imageSrc.length) {
      return Math.ceil(3 / 4 * this.imageSrc.length / 1024);
    } else {
      return;
    }
  }
  ////////////////////////////////////////////////
  onRemove() {
    this.imageSrc = null;
    this.loadImage = false;
    this.$imageOriginal.next(null);
    this.$imageChanged.next(null);
    this.state = {
      ...this.state,
      originImageSrc: '',
      format: 'jpeg',
      maxHeight: 1000,
      maxWidth: 1000,
      cropHeight: 150,
      cropWidth: 150,
      maintainAspectRatio: true,
      arrayCopiedImages: []
    };
    this.showEditPanel = false;
  }
}
NgpImagePickerComponent.ɵfac = function NgpImagePickerComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgpImagePickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
};
NgpImagePickerComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: NgpImagePickerComponent,
  selectors: [["ngp-image-picker"]],
  viewQuery: function NgpImagePickerComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(_c6, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.imagePicker = _t.first);
    }
  },
  inputs: {
    color: "color",
    _imageSrc: "_imageSrc",
    _config: "_config"
  },
  outputs: {
    $imageChanged: "$imageChanged",
    $imageOriginal: "$imageOriginal"
  },
  decls: 3,
  vars: 3,
  consts: [["imagePicker", ""], ["class", "place-image", 4, "ngIf"], [3, "imageSrc", "originImageSrc", "initialState", "labels", "color", "closeModal", 4, "ngIf"], [1, "place-image"], [1, "image-holder", 3, "ngStyle"], [1, "icon-btn", "image-upload-btn", 3, "click", "title"], [1, "material-icons"], ["type", "file", 2, "display", "none", 3, "change", "id"], [1, "image-holder-loaded", 3, "ngStyle"], ["alt", "image-loaded", 3, "src", "ngStyle"], ["class", "caption image-caption", 3, "ngStyle", 4, "ngIf"], [1, "editing-bar-btn", 2, "flex-direction", "row", "box-sizing", "border-box", "display", "flex", "place-content", "flex-start", "align-items", "flex-start"], ["class", "icon-btn", "id", "upload-img", 3, "title", "click", 4, "ngIf"], ["class", "icon-btn", "id", "edit-img", 3, "title", "click", 4, "ngIf"], ["id", "download-img", 3, "title", "href", "download", 4, "ngIf"], ["class", "icon-btn", "id", "delete-img", 3, "title", "click", 4, "ngIf"], [1, "caption", "image-caption", 3, "ngStyle"], ["id", "upload-img", 1, "icon-btn", 3, "click", "title"], ["id", "edit-img", 1, "icon-btn", 3, "click", "title"], ["id", "download-img", 3, "title", "href", "download"], ["id", "delete-img", 1, "icon-btn", 3, "click", "title"], [3, "closeModal", "imageSrc", "originImageSrc", "initialState", "labels", "color"]],
  template: function NgpImagePickerComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵtemplate(0, NgpImagePickerComponent_div_0_Template, 7, 7, "div", 1)(1, NgpImagePickerComponent_div_1_Template, 11, 15, "div", 1)(2, NgpImagePickerComponent_lib_edit_image_2_Template, 1, 5, "lib-edit-image", 2);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", !ctx.loadImage);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.loadImage);
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.showEditPanel);
    }
  },
  dependencies: [EditImageComponent, i1.NgIf, i1.NgStyle],
  styles: ["ngp-image-picker p{margin:0!important;padding:0!important}ngp-image-picker .place-image{flex-direction:column;box-sizing:border-box;display:flex;place-content:flex-start;align-items:flex-start}ngp-image-picker .place-image .image-holder{flex-direction:column;display:flex;place-content:center;align-items:center;position:relative;width:320px;height:240px;border-radius:16px;max-width:100%!important;box-sizing:border-box;border:2px rgba(0,0,0,.3) solid;background-color:#fcfcfc}@media (max-width: 599px){ngp-image-picker .place-image .image-holder{max-width:100%!important;max-height:250px!important}}ngp-image-picker .place-image .image-holder .image-upload-btn{transition:all .5s ease;position:relative;opacity:.85;width:50px;height:50px;color:#424242}ngp-image-picker .place-image .image-holder .image-upload-btn .material-icons{font-size:50px;width:50px;height:50px;line-height:50px;color:#424242}@media (max-width: 599px){ngp-image-picker .place-image .image-holder .image-upload-btn{opacity:1;width:30px;height:30px}ngp-image-picker .place-image .image-holder .image-upload-btn .material-icons{font-size:30px;width:30px;height:30px;line-height:30px}}ngp-image-picker .place-image .image-holder:hover .image-upload-btn{opacity:1;transition:all .5s ease}ngp-image-picker .place-image .image-holder-loaded{flex-direction:column;display:flex;place-content:center;align-items:center;position:relative;max-width:100%!important;width:320px;height:240px;border-radius:4px;box-sizing:border-box;padding:2px}ngp-image-picker .place-image .image-holder-loaded .image-caption{position:absolute;right:0;bottom:-22px}ngp-image-picker .place-image .image-holder-loaded img{height:100%;max-height:100%;width:100%;max-width:100%;object-fit:cover;object-position:center}@media (max-width: 599px){ngp-image-picker .place-image .image-holder-loaded{max-height:195px!important}}ngp-image-picker .place-image .image-holder-loaded .image-upload-btn{transition:all .5s ease;position:relative;opacity:.85;width:50px;height:50px;color:#424242}ngp-image-picker .place-image .image-holder-loaded .image-upload-btn .material-icons{font-size:50px;width:50px;height:50px;line-height:50px;color:#424242}@media (max-width: 599px){ngp-image-picker .place-image .image-holder-loaded .image-upload-btn{opacity:1;width:30px;height:30px}ngp-image-picker .place-image .image-holder-loaded .image-upload-btn .material-icons{font-size:30px;width:30px;height:30px;line-height:30px}}ngp-image-picker .place-image .image-holder-loaded:hover .image-upload-btn{opacity:1;transition:all .5s ease}ngp-image-picker .place-image .editing-bar-btn{margin-top:2px}ngp-image-picker .place-image .editing-bar-btn .material-icons-button{height:20px;line-height:20px;width:24px}ngp-image-picker .place-image .editing-bar-btn .material-icons{line-height:20px!important;font-size:20px!important;width:20px!important;height:20px!important}ngp-image-picker .place-image .editing-bar-btn button{margin:4px;color:#424242;transition:all .5s ease}ngp-image-picker .place-image .editing-bar-btn button:hover{transition:all .25s ease-in}ngp-image-picker .place-image .editing-bar-btn a{margin:4px;color:#424242;transition:all .5s ease}ngp-image-picker .place-image .editing-bar-btn a:hover{transition:all .25s ease-in}ngp-image-picker .popup{width:100vw;max-height:100%;height:100%;overflow:auto;position:fixed;top:0;left:0;background-color:#000c;z-index:1000;padding:24px;color:#fff;box-sizing:border-box;animation-name:show;animation-duration:.4s}ngp-image-picker .popup .image-container{margin-top:50px;margin-bottom:50px;width:100%;flex-flow:row wrap;box-sizing:border-box;display:flex;place-content:flex-start center;align-items:flex-start}ngp-image-picker .popup .image-container .image-holder-full{height:auto;width:auto;position:relative;display:contents}ngp-image-picker .popup .material-icons{color:#fff}ngp-image-picker .popup img{max-height:600px;max-width:100%;object-fit:cover;object-position:center;margin:8px;transition:all .5s ease}@media (max-width: 1024px){ngp-image-picker .popup{background-color:#000000d9;padding:8px}ngp-image-picker .popup img{max-height:100%;max-width:100%}}@media (max-width: 599px){ngp-image-picker .popup img{margin:0}}ngp-image-picker .popup .control-panel{color:#fff;background-color:#000000eb;margin:8px;padding:16px;width:18rem;border-radius:8px;flex-direction:column;box-sizing:border-box;display:flex;place-content:stretch flex-start;align-items:stretch;max-width:100%}@media (max-width: 599px){ngp-image-picker .popup .control-panel{margin:8px 0;width:100%}}ngp-image-picker .popup .control-panel .title-panel{padding:0 4px;font-size:17px;font-weight:500;margin-bottom:16px!important}ngp-image-picker .popup .control-panel .item-panel{padding:0;font-size:14px;font-weight:500}@keyframes show{0%{top:-100vh;opacity:0}to{top:0;opacity:1}}ngp-image-picker .btn{padding:4px 8px;border-radius:4px;cursor:pointer}ngp-image-picker .btn .material-icons{color:#000000d1}ngp-image-picker .icon-btn{display:flex;justify-content:center;align-items:center;border:none;background-color:inherit;border-radius:50%;cursor:pointer}ngp-image-picker .icon-btn :active{transform:scale(.95)}ngp-image-picker .caption{font-size:11px;margin-top:2px!important;margin-bottom:0!important}ngp-image-picker button[disabled]{filter:brightness(.5);cursor:not-allowed}\n"],
  encapsulation: 2,
  changeDetection: 0
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgpImagePickerComponent, [{
    type: Component,
    args: [{
      selector: 'ngp-image-picker',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div *ngIf=\"!loadImage\" class=\"place-image\">\n  <div\n    class=\"image-holder\"\n    [ngStyle]=\"{\n      width: this.config.width,\n      height: this.config.height,\n      borderRadius: this.config.borderRadius\n    }\"\n  >\n    <button title=\"{{ labels['Upload a image'] }}\" class=\"icon-btn image-upload-btn\" (click)=\"onUpload($event)\">\n      <!--  <span class=\"material-icons\">add_a_photo</mat-icon> -->\n      <span class=\"material-icons\">add_a_photo</span>\n    </button>\n\n    <input #imagePicker type=\"file\" style=\"display: none\" [id]=\"'filePicker-' + this.uuidFilePicker\" (change)=\"handleFileSelect($event)\" />\n  </div>\n</div>\n<div *ngIf=\"loadImage\" class=\"place-image\">\n  <div\n    class=\"image-holder-loaded\"\n    [ngStyle]=\"{\n      width: this.config.width,\n      height: this.config.height,\n      borderRadius: this.config.borderRadius\n    }\"\n  >\n    <img [src]=\"this.imageSrc\" alt=\"image-loaded\" [ngStyle]=\"{ borderRadius: this.config.borderRadius }\" />\n    <input #imagePicker type=\"file\" style=\"display: none\" [id]=\"'filePicker-' + this.uuidFilePicker\" (change)=\"handleFileSelect($event)\" />\n  </div>\n  <p\n    *ngIf=\"this.calculateSize()\"\n    class=\"caption image-caption\"\n    [ngStyle]=\"{\n      color: this.calculateSize() > 120 ? '#f44336' : 'unset',\n      fontWeight: this.calculateSize() > 120 ? '500' : 'unset'\n    }\"\n  >\n    size: {{ this.calculateSize() }}Kb &nbsp; {{ this.state.format }}\n  </p>\n\n  <div\n    style=\"flex-direction: row; box-sizing: border-box; display: flex; place-content: flex-start; align-items: flex-start\"\n    class=\"editing-bar-btn\"\n  >\n    <button\n      class=\"icon-btn\"\n      id=\"upload-img\"\n      *ngIf=\"!this.config.hideAddBtn\"\n      title=\"{{ labels['Upload a image'] }}\"\n      (click)=\"onUpload($event)\"\n    >\n      <span class=\"material-icons\">add_a_photo</span>\n    </button>\n    <button\n      class=\"icon-btn\"\n      id=\"edit-img\"\n      *ngIf=\"!this.config.hideEditBtn\"\n      title=\"{{ labels['Open the editor panel'] }}\"\n      (click)=\"onOpenEditPanel()\"\n    >\n      <span class=\"material-icons\">edit</span>\n    </button>\n    <a\n      id=\"download-img\"\n      *ngIf=\"!this.config.hideDownloadBtn\"\n      title=\"{{ labels['Download the image'] }}\"\n      [href]=\"this.imageSrc\"\n      download=\"{{ imageName }}\"\n    >\n      <span class=\"material-icons\">cloud_download</span>\n    </a>\n    <button class=\"icon-btn\" id=\"delete-img\" *ngIf=\"!this.config.hideDeleteBtn\" title=\"{{ labels['Remove'] }}\" (click)=\"onRemove()\">\n      <span class=\"material-icons\">delete</span>\n    </button>\n  </div>\n</div>\n\n<lib-edit-image\n  *ngIf=\"showEditPanel\"\n  [imageSrc]=\"this.imageSrc\"\n  [originImageSrc]=\"this.originImageSrc\"\n  [initialState]=\"this.state\"\n  [labels]=\"this.labels\"\n  [color]=\"this.color\"\n  (closeModal)=\"this.onCloseEditPanel($event)\"\n></lib-edit-image>\n",
      styles: ["ngp-image-picker p{margin:0!important;padding:0!important}ngp-image-picker .place-image{flex-direction:column;box-sizing:border-box;display:flex;place-content:flex-start;align-items:flex-start}ngp-image-picker .place-image .image-holder{flex-direction:column;display:flex;place-content:center;align-items:center;position:relative;width:320px;height:240px;border-radius:16px;max-width:100%!important;box-sizing:border-box;border:2px rgba(0,0,0,.3) solid;background-color:#fcfcfc}@media (max-width: 599px){ngp-image-picker .place-image .image-holder{max-width:100%!important;max-height:250px!important}}ngp-image-picker .place-image .image-holder .image-upload-btn{transition:all .5s ease;position:relative;opacity:.85;width:50px;height:50px;color:#424242}ngp-image-picker .place-image .image-holder .image-upload-btn .material-icons{font-size:50px;width:50px;height:50px;line-height:50px;color:#424242}@media (max-width: 599px){ngp-image-picker .place-image .image-holder .image-upload-btn{opacity:1;width:30px;height:30px}ngp-image-picker .place-image .image-holder .image-upload-btn .material-icons{font-size:30px;width:30px;height:30px;line-height:30px}}ngp-image-picker .place-image .image-holder:hover .image-upload-btn{opacity:1;transition:all .5s ease}ngp-image-picker .place-image .image-holder-loaded{flex-direction:column;display:flex;place-content:center;align-items:center;position:relative;max-width:100%!important;width:320px;height:240px;border-radius:4px;box-sizing:border-box;padding:2px}ngp-image-picker .place-image .image-holder-loaded .image-caption{position:absolute;right:0;bottom:-22px}ngp-image-picker .place-image .image-holder-loaded img{height:100%;max-height:100%;width:100%;max-width:100%;object-fit:cover;object-position:center}@media (max-width: 599px){ngp-image-picker .place-image .image-holder-loaded{max-height:195px!important}}ngp-image-picker .place-image .image-holder-loaded .image-upload-btn{transition:all .5s ease;position:relative;opacity:.85;width:50px;height:50px;color:#424242}ngp-image-picker .place-image .image-holder-loaded .image-upload-btn .material-icons{font-size:50px;width:50px;height:50px;line-height:50px;color:#424242}@media (max-width: 599px){ngp-image-picker .place-image .image-holder-loaded .image-upload-btn{opacity:1;width:30px;height:30px}ngp-image-picker .place-image .image-holder-loaded .image-upload-btn .material-icons{font-size:30px;width:30px;height:30px;line-height:30px}}ngp-image-picker .place-image .image-holder-loaded:hover .image-upload-btn{opacity:1;transition:all .5s ease}ngp-image-picker .place-image .editing-bar-btn{margin-top:2px}ngp-image-picker .place-image .editing-bar-btn .material-icons-button{height:20px;line-height:20px;width:24px}ngp-image-picker .place-image .editing-bar-btn .material-icons{line-height:20px!important;font-size:20px!important;width:20px!important;height:20px!important}ngp-image-picker .place-image .editing-bar-btn button{margin:4px;color:#424242;transition:all .5s ease}ngp-image-picker .place-image .editing-bar-btn button:hover{transition:all .25s ease-in}ngp-image-picker .place-image .editing-bar-btn a{margin:4px;color:#424242;transition:all .5s ease}ngp-image-picker .place-image .editing-bar-btn a:hover{transition:all .25s ease-in}ngp-image-picker .popup{width:100vw;max-height:100%;height:100%;overflow:auto;position:fixed;top:0;left:0;background-color:#000c;z-index:1000;padding:24px;color:#fff;box-sizing:border-box;animation-name:show;animation-duration:.4s}ngp-image-picker .popup .image-container{margin-top:50px;margin-bottom:50px;width:100%;flex-flow:row wrap;box-sizing:border-box;display:flex;place-content:flex-start center;align-items:flex-start}ngp-image-picker .popup .image-container .image-holder-full{height:auto;width:auto;position:relative;display:contents}ngp-image-picker .popup .material-icons{color:#fff}ngp-image-picker .popup img{max-height:600px;max-width:100%;object-fit:cover;object-position:center;margin:8px;transition:all .5s ease}@media (max-width: 1024px){ngp-image-picker .popup{background-color:#000000d9;padding:8px}ngp-image-picker .popup img{max-height:100%;max-width:100%}}@media (max-width: 599px){ngp-image-picker .popup img{margin:0}}ngp-image-picker .popup .control-panel{color:#fff;background-color:#000000eb;margin:8px;padding:16px;width:18rem;border-radius:8px;flex-direction:column;box-sizing:border-box;display:flex;place-content:stretch flex-start;align-items:stretch;max-width:100%}@media (max-width: 599px){ngp-image-picker .popup .control-panel{margin:8px 0;width:100%}}ngp-image-picker .popup .control-panel .title-panel{padding:0 4px;font-size:17px;font-weight:500;margin-bottom:16px!important}ngp-image-picker .popup .control-panel .item-panel{padding:0;font-size:14px;font-weight:500}@keyframes show{0%{top:-100vh;opacity:0}to{top:0;opacity:1}}ngp-image-picker .btn{padding:4px 8px;border-radius:4px;cursor:pointer}ngp-image-picker .btn .material-icons{color:#000000d1}ngp-image-picker .icon-btn{display:flex;justify-content:center;align-items:center;border:none;background-color:inherit;border-radius:50%;cursor:pointer}ngp-image-picker .icon-btn :active{transform:scale(.95)}ngp-image-picker .caption{font-size:11px;margin-top:2px!important;margin-bottom:0!important}ngp-image-picker button[disabled]{filter:brightness(.5);cursor:not-allowed}\n"]
    }]
  }], function () {
    return [{
      type: i0.ChangeDetectorRef
    }];
  }, {
    color: [{
      type: Input
    }],
    _imageSrc: [{
      type: Input
    }],
    _config: [{
      type: Input
    }],
    imagePicker: [{
      type: ViewChild,
      args: ['imagePicker', {
        static: false
      }]
    }],
    $imageChanged: [{
      type: Output
    }],
    $imageOriginal: [{
      type: Output
    }]
  });
})();
class NgpImagePickerModule {}
NgpImagePickerModule.ɵfac = function NgpImagePickerModule_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || NgpImagePickerModule)();
};
NgpImagePickerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: NgpImagePickerModule
});
NgpImagePickerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  providers: [],
  imports: [[CommonModule, FormsModule, ReactiveFormsModule]]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgpImagePickerModule, [{
    type: NgModule,
    args: [{
      declarations: [NgpImagePickerComponent, TabsComponent, EditImageComponent, BasicFiltersComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule],
      exports: [NgpImagePickerComponent],
      providers: []
    }]
  }], null, null);
})();

/*
 * Public API Surface of ngp-image-picker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgpImagePickerComponent, NgpImagePickerModule };
